import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breadcrumb-signage-add',
    templateUrl: './breadcrumb.signage.add.component.html'
})

export class BreadcrumbSignageAddComponent {
    @Input() companyId: number;
    @Input() facilityId: number;
    @Input() kioskId: number;

    roleMatrix: RoleMatrix;


    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
